import Hero from "components/affiliates/hero";
import SectionOne from "components/affiliates/sectionOne";
import SectionTwo from "components/affiliates/sectionTwo";
import Slider from "components/affiliates/slider";
import Head from "next/head";
import styled from "styled-components";

const StyledWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;
const StyledContainer = styled.div`
  width: 100%;
  max-width: 1280px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Pricing = () => {
  return (
    <>
      <Head>
        <title>Redact - Premium</title>
        <meta charSet="utf-8" />
        <link rel="icon" href="/images/favicon.ico" />
        <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
        <meta name="theme-color" content="#000000" />
        <meta name="robots" content="noarchive" />
        <meta
          name="description"
          content="Redact is a service that can easily mass delete your messages, posts, and comments on Twitter, Reddit, Discord, Facebook, and more."
        />
        <meta name="keywords" content="redact mass delete privacy free" />

        <meta
          property="og:title"
          content="Redact - Mass delete your posts and messages on Social Networks"
        />
        <meta
          property="og:description"
          content="Mass delete your messages, posts and comments on Twitter, Reddit, Discord, Facebook, and more, all from one free app."
        />

        <meta property="og:url" content="https://www.redact.dev" />
        <link rel="apple-touch-icon" href="images/logo192.png" />
      </Head>
      <div>
        <StyledWrapper>
          <StyledContainer>
            <Hero />
            <Slider />
            <SectionOne />
            <SectionTwo />
          </StyledContainer>
        </StyledWrapper>
      </div>
    </>
  );
};

export default Pricing;
